import { withApiContext, withLabelsContext, withUserContext } from "context";
import React, { useEffect, useState } from "react";
import "./CourseList.css";
import { Col, Row, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { IconCourseBook, IconSearchText } from "Icons";

function CourseTestList(props) {
  const [filteredCourses, setFilteredCourses] = useState(props.allCourses);
  const [visibleIndex, setVisibleIndex] = useState(1);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [query, setQuery] = useState("");
  const ITEMS_PER_PAGE = 10;

  useEffect(() => {
  setFilteredCourses(props.allCourses);   // reset when parent updates
}, [props.allCourses]);  

  const findChapter = (e) => {
    const currentVal = e.target.value;      // ✅ correct
    setQuery(currentVal);                   // keep the input controlled

    const filtered = props.allCourses.filter(course =>
      course.name.toLowerCase().includes(currentVal.toLowerCase())
    );

    setFilteredCourses(filtered);
    // setVisibleIndex(1+1);                     // reset pagination / slicing
  };


  const handleSeeMore = () => {
  setVisibleIndex(prev => {
    const next = prev + 1;
    props.handleSeeMore(next);
    return next;
  });
};

  

  const findCourse = (query) => {
    setQuery(query)
    props.handleCourseName(query)
  }

  const handleExit = () => {
    setSelectedCourse(null);
    setQuery("")
    props.selectedCourse(null);
  };

  const handleCourseClick = (course) => {
    setSelectedCourse(course);
    props.selectedCourse(course); // Set the selected course
  };

  const trimCourseName = (courseName) => {

    return courseName?.length > 45
      ? courseName.substring(0, 45) + "..."
      : courseName;
  };

  const isTrimmed = (courseName) => {
    return courseName?.length > 45;
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };
  const handleSearch = () => {
    props.CourseName(query); // pass query if needed
  };
  return (
    <>

      {!selectedCourse && (
        <section className="course-card">
          <div className="card-head">
            <span>{props.isCoursePublish ?  "Choose a course from below" : "Choose a test from below"}</span>
            <div className="search-box">
              <span className="search-icon"><IconSearchText /></span>
              <input
                value={query}
              onChange={(e) => {
    setQuery(e.target.value);
    props.CourseName(e.target.value); // send to parent on each letter
  }}
               onKeyDown={handleKeyDown}
               onClick={handleSearch}
                placeholder={props.isCoursePublish ?  "Search a Course" : "Search a test"}
              />
            </div>
          </div>

       <ul className="course-list">
  {filteredCourses.length > 0 && !query ? (
    <>
      {filteredCourses.map((c, i) => (
        <li key={i}>
          <span className="ellipsis" onClick={() => handleCourseClick(c)}>
            <IconCourseBook /> {c.name}
          </span>
        </li>
      ))}

      <button
        onClick={handleSeeMore}
        className={`see-more-btn ${props.seeMore ? "disabled" : ""}`}
        disabled={props.seeMore}
      >
        See More
      </button>
    </>
  ) : props.courses.length > 0 && query ? (
    <>
      {props.courses.map((c, i) => (
        <li key={i}>
          <span className="ellipsis" onClick={() => handleCourseClick(c)}>
            <IconCourseBook /> {c.name}
          </span>
        </li>
      ))}
    </>
  ) : (
    <li className="no-match">No matching courses</li>
  )}
</ul>


        </section>)


      }
      {selectedCourse && (
        <>
          <div className="course-sep">
            <IconCourseBook />{" "}
            <span title={selectedCourse.name}>
              {selectedCourse.name}
            </span>
          </div>
          <Row>
            <Col md={8}>
            <span className="txt-msg">{props.pubType === "" && (props.isCoursePublish ? "Choosen a wrong course?" : "Choosen a wrong assessment?")}</span>
           </Col>
           <Col md={4}>
            {props.pubType === "" && <Button className="yes-btn" onClick={handleExit}>Yes</Button>}
            </Col>
          </Row>
        </>
      )}
    </>
  );
}

export default withLabelsContext(withApiContext(withUserContext(CourseTestList)));

